import React, { useEffect } from "react";
import { ICreditResponse } from "../../../../store/credit/types";
import CreditScoreType from "../../CreditScore/CreditScoreType";
import { getScoreRating, getScoreStatus } from "../../../../util/credit";
import { useTranslation } from "react-i18next";

interface IProps {
    data?: ICreditResponse;
    isTUUser?: boolean;
}

const PrintCreditScoreAllBureau: React.FunctionComponent<IProps> = (props) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const ensureDataFetched = () => {
        if (props.data != null && props.data.scores != null) {
            props.data.scores.forEach(function (score) {
                let scoreDesc = getScoreRating(score["risk-score"], tLang);
                score["score-desc"] = scoreDesc;
            });
        }
    };

    

    useEffect(ensureDataFetched, [props.data]);

    return (
        <div className="box offset-padding">
            {(props.data != null && props.data.scores != null && props.data.scores.length > 0) ? (
                <div className="box-header">
                    <div className="box-title-container">
                        <div className="box-title-text">
                            <h2 className="box-title">{tLang("dashboard.creditScore.title")}</h2>
                        </div>
                    </div>
                    <div className="box-actions"></div>
                </div>
            ) : null}
            <div className="box-content">
                {props.data != null ? (
                    <ul className="credit-bureau-list">
                        {props.data.scores &&
                            props.data.scores.map((score) => (
                                <CreditScoreType
                                    key={score.type}
                                    scoreValue={score["risk-score"]}
                                    scoreRating={score["score-desc"]}
                                    population={score["population-rank"]}
                                    title={score.abbreviation}
                                    logo={``}
                                    updated={score["inquiry-date"]}
                                    isIDFUser={props.data == null ? true : props.data.IsIDFUser}
                                    status={getScoreStatus(score["risk-score"])}
                                    isTUUser={props.isTUUser}
                                />
                            ))}
                    </ul>
                ) : null}
            </div>
        </div>
    );
};
export default PrintCreditScoreAllBureau;
